// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"Input_inputWrapper__2LFOb"};